import { useEffect, useState } from "react";
import xss from "xss";
import useDeviceSize from "@/hooks/useDeviceSize";

interface GuideItem {
  type: string;
  content: string;
}

interface RefundPolicyItem {
  category: string;
  cancelFee: number | string;
}

interface TabInfoBoxProps {
  guideData: unknown[];
  refundPolicyInfoList: unknown[];
}

const TabInfoBox = ({ guideData, refundPolicyInfoList }: TabInfoBoxProps) => {
  const [activeTab, setActiveTab] = useState("인원 및 금액");
  const tabList = ["인원 및 금액", "예약 및 결제", "시설 안내", "서비스 안내"];
  const [peopleAndAmounQuillValue, setPeopleAndAmounQuillValue] = useState<string>();
  const [reservationAndPaymentQuillValue, setReservationAndPaymentQuillValue] =
    useState<string>();
  const [facilityInformationQuillValue, setFacilityInformationQuillValue] =
    useState<string>();
  const [serviceInformationQuillValue, setServiceInformationQuillValue] =
    useState<string>();
  const isDesktop = useDeviceSize();

  useEffect(() => {
    (guideData as GuideItem[])?.map((gg) => {
      if (gg.type == "PEOPLE_AND_AMOUNT")
        setPeopleAndAmounQuillValue(gg.content);
      if (gg.type == "RESERVATION_AND_PAYMENT")
        setReservationAndPaymentQuillValue(gg.content);
      if (gg.type == "FACILITY_INFORMATION")
        setFacilityInformationQuillValue(gg.content);
      if (gg.type == "SERVICE_INFORMATION")
        setServiceInformationQuillValue(gg.content);
    });
  }, [guideData]);

  const contentStyle = `
    .content-container h1, .content-container h2, .content-container h3,
    .content-container h4, .content-container p, .content-container div {
      margin-bottom: 7px;
      line-height: 1.2;
    }
    .content-container ul, .content-container ol {
      margin-left: 3px;
      margin-bottom: 3px;
    }
    .content-container li {
      margin-bottom: 3px;
    }
    .content-container * {
      font-family: inherit;
      word-break: keep-all;
      word-wrap: break-word;
    }
    .content-container strong {
      font-weight: 400;
    }
  `;

 return (
    <div>
      <style>{contentStyle}</style>
      <div
        className={`text-[30px] font-500 mb-[60px] text-left mobile:mb-[32px] mobile:text-[20px] mobile:text-center`}
      >
        스테이 이용 안내사항을 확인해 주세요.
      </div>
      <div
        className={`flex gap-[33px] mb-[40px] justify-start mobile:gap-[20px] mobile:justify-center`}
      >
        {tabList.map((tab) => (
          <div
            key={tab}
            className={`cursor-pointer text-[16px] mobile:text-[14px] ${
              activeTab === tab ? "font-600" : "font-400 text-[#767676]"
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </div>
        ))}
      </div>
      <div className="bg-[#eaeaea] relative p-[24px] rounded-md">
        {activeTab === "인원 및 금액" && (
          <div
            className="w-full max-w-[1000px] h-full mx-auto content-container mobile:w-full mobile:text-[16px]"
            dangerouslySetInnerHTML={{
              __html: xss(
                peopleAndAmounQuillValue != null
                  ? String(peopleAndAmounQuillValue)
                  : ""
              ),
            }}
          ></div>
        )}
        {activeTab === "예약 및 결제" && (
          <>
            <div
              className="w-full max-w-[1000px] h-full mx-auto content-container mobile:w-full mobile:text-[16px]"
              dangerouslySetInnerHTML={{
                __html: xss(
                  reservationAndPaymentQuillValue != null
                    ? String(reservationAndPaymentQuillValue)
                    : ""
                ),
              }}
            ></div>
         <div className="w-full max-w-[1000px] h-full mx-auto mt-8 mobile:w-full mobile:text-[16px]">
              <div className="text-[24px] font-500 mb-4 mobile:text-[20px]">환불 수수료</div>
              <div>
                <table className="mt-[20px]">
                  <tr>
                    <td>기준일</td>
                    <td>취소 수수료</td>
                  </tr>
                  {(refundPolicyInfoList as RefundPolicyItem[]).map((refund, index: number) => (
                    <tr key={index} className="list-inside">
                      <td>{refund.category}</td>
                      <td>{refund.cancelFee}</td>
                    </tr>
                  ))}
                </table>
              </div>
            </div>
          </>
        )}
        {activeTab === "시설 안내" && (
          <div
            className="w-full max-w-[1000px] h-full mx-auto content-container mobile:w-full mobile:text-[16px]"
            dangerouslySetInnerHTML={{
              __html: xss(
                facilityInformationQuillValue != null
                  ? String(facilityInformationQuillValue)
                  : ""
              ),
            }}
          ></div>
        )}
        {activeTab === "서비스 안내" && (
          <div
            className="w-full max-w-[1000px] h-full mx-auto content-container mobile:w-full mobile:text-[16px]"
            dangerouslySetInnerHTML={{
              __html: xss(
                serviceInformationQuillValue != null
                  ? String(serviceInformationQuillValue)
                  : ""
              ),
            }}
          ></div>
        )}
      </div>
    </div>
  );
};

//   return (
//     <div>
//       <div
//         className={`text-[30px] font-500 mb-[60px] text-left mobile:mb-[32px] mobile:text-[20px] mobile:text-center   `}
//       >
//         스테이 이용 안내사항을 확인해 주세요.
//       </div>
//       <div
//         className={`flex gap-[33px] mb-[40px] justify-start mobile:gap-[20px] mobile:justify-center `}
//       >
//         {tabList.map((tab) => (
//           <div
//             key={tab}
//             className={`cursor-pointer text-[16px] mobile:text-[14px] ${
//               activeTab === tab ? "font-600" : "font-400 text-[#929292]"
//             }`}
//             onClick={() => setActiveTab(tab)}
//           >
//             {tab}
//           </div>
//         ))}
//       </div>
//       <div className="bg-[#eaeaea] relative p-[12px]">
//         {activeTab === "인원 및 금액" && (
//           <div
//             className="w-[1000px] h-full m-auto leading-[20px] overflow-auto mobile:w-full mobile:h-full mobile:text-[16px] "
//             dangerouslySetInnerHTML={{
//               __html: xss(
//                 peopleAndAmounQuillValue != null
//                   ? String(peopleAndAmounQuillValue)
//                   : ""
//               ),
//             }}
//           ></div>
//         )}
//         {activeTab === "예약 및 결제" && (
//           <>
//             <div
//               className="w-[1000px] h-full m-auto leading-[20px] overflow-auto mobile:w-full mobile:h-full mobile:text-[16px]"
//               dangerouslySetInnerHTML={{
//                 __html: xss(
//                   reservationAndPaymentQuillValue != null
//                     ? String(reservationAndPaymentQuillValue)
//                     : ""
//                 ),
//               }}
//             ></div>
//             <div className="w-[1000px] h-full m-auto leading-[20px]  mobile:w-full mobile:h-full mobile:text-[16px]">
//               <div className="text-[24px] mobile:text-[20px]">환불 수수료</div>
//               <div>
//                 <table className="mt-[20px]">
//                   <tr>
//                     <td>기준일</td>
//                     <td>취소 수수료</td>
//                   </tr>
//                   {refundPolicyInfoList.map((refund: any) => (
//                     <tr className="list-inside">
//                       <td>{refund.category}</td>
//                       <td>{refund.cancelFee}</td>
//                     </tr>
//                   ))}
//                 </table>
//               </div>
//             </div>
//           </>
//         )}
//         {activeTab === "시설 안내" && (
//           <div
//             className="w-[1000px] h-full m-auto leading-[20px] overflow-auto mobile:w-full mobile:h-full mobile:text-[16px]"
//             dangerouslySetInnerHTML={{
//               __html: xss(
//                 facilityInformationQuillValue != null
//                   ? String(facilityInformationQuillValue)
//                   : ""
//               ),
//             }}
//           ></div>
//         )}
//         {activeTab === "서비스 안내" && (
//           <div
//             className="w-[1000px] h-full m-auto leading-[20px] overflow-auto mobile:w-full mobile:h-full mobile:text-[16px]"
//             dangerouslySetInnerHTML={{
//               __html: xss(
//                 serviceInformationQuillValue != null
//                   ? String(serviceInformationQuillValue)
//                   : ""
//               ),
//             }}
//           ></div>
//         )}
//       </div>
//     </div>
//   );
// };

export default TabInfoBox;
